import React, { useEffect } from "react";
import { Typography, Button } from "antd";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { accountBaseUrl } from "../../helpers/account";
import { fetchCurrentLocationRequest } from "../Location/actions";
import { setPatientType } from "../Booking/actions";
import ContentContainer from "../../components/ContentContainer";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { isMobile } from "react-device-detect";
import { trackEvent, setSessionContext, trackButtonClick } from "utils/analytics";
import usePageView from "../../hooks/usePageView";
import { isEmpty } from "lodash";

const PatientType = ({ match }) => {
	const { params } = match;
	const { locationId: practiceId, practitionerId } = params;
	const history = useHistory();
	const dispatch = useDispatch();

	const currentLocation = useSelector(
		(state) => state.locations.currentLocation,
	);

	// Track page view with step info
	usePageView("Patient Type Selection", 1, "patient_type", 20);

	// Set location context when available
	useEffect(() => {
		if (currentLocation?.id) {
			setSessionContext({
				locationId: currentLocation.id,
				locationName: currentLocation.name,
				isStandaloneMode: currentLocation.standaloneMode || false,
			});
		}
	}, [currentLocation]);

	useEffect(() => {
		if (isEmpty(currentLocation)) {
			dispatch(fetchCurrentLocationRequest(practiceId));
		}
	}, [currentLocation, practiceId, dispatch]);

	const handleSelect = (type) => {
		dispatch(setPatientType(type));

		// Set patient type in session context so it persists across all events
		setSessionContext({ patientType: type });
		trackEvent("patient_type_selected", { patient_type: type });
		trackButtonClick(type === 'new' ? 'new_patient_button' : 'existing_patient_button');

		const base = `${accountBaseUrl}/locations/${practiceId}`;
		if (practitionerId) {
			history.push(`${base}/practitioner/${practitionerId}/reasons`);
		} else {
			history.push(`${base}/reasons`);
		}
	};

	return (
		<ContentContainer
			pageTitle="Welcome! Let's get you booked in"
			themeColor={currentLocation?.themeColor}
			step="1"
			showNext={false}
			stepPercentage={20}
			backButton={
				<Button
					onClick={() => history.goBack()}
					shape="circle"
					type="text"
					icon={<ArrowLeftOutlined />}
				/>
			}
		>
			<div style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				minHeight: isMobile ? '40vh' : '30vh',
				textAlign: 'center',
			}}>
				<Typography.Title level={isMobile ? 5 : 4} style={{ marginBottom: 8 }}>
					Who is this booking for?
				</Typography.Title>
				<Typography.Text type="secondary" style={{ marginBottom: 24, display: 'block' }}>
					This helps us show you the right services
				</Typography.Text>
				<div style={{ display: 'flex', gap: 12 }}>
					{['new', 'existing'].map((type) => {
						const label = type === 'new' ? 'New patient' : 'Existing patient';
						return (
							<Button
								key={type}
								size="large"
								shape="round"
								onClick={() => handleSelect(type)}
								style={{
									height: 44,
									paddingLeft: 24,
									paddingRight: 24,
									fontWeight: 500,
								}}
							>
								{label}
							</Button>
						);
					})}
				</div>
			</div>
		</ContentContainer>
	);
};

export default PatientType;
